import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ManageClients.css"; 

const ManageClients = () => {
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ব্যাকএন্ড থেকে ক্লায়েন্ট লিস্ট ফেচ করা
  const fetchClients = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/clients/list");
      
      const rawData = res.data?.data || res.data || [];
      const data = Array.isArray(rawData) ? rawData : [];
      
      setClients(data);
      setFilteredClients(data);
    } catch (err) {
      console.error("Error fetching clients repository:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { 
    fetchClients(); 
  }, []);

  // সার্চ এবং রিয়েল-টাইম ফিল্টারিং লজিক (Client Name, Network/ISP অথবা Mobile দিয়ে সার্চ করা যাবে)
  useEffect(() => {
    const results = clients.filter((client) =>
      (client.customer_name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (client.network_name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (client.phone || "").includes(searchTerm)
    );
    setFilteredClients(results);
  }, [searchTerm, clients]);

  return (
    <div className="manage-clients-container">
      
      {/* HEADER SECTION (NO TOP BACK BUTTON) */}
      <div className="manage-clients-header-wrapper" style={{ marginBottom: "24px" }}>
        <div>
          <h2 style={{ margin: 0, fontSize: "24px", color: "#1e293b", fontWeight: "800" }}>Manage Clients & Clusters</h2>
          <p className="manage-clients-subtitle" style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>
            Overview of all registered operational subscription nodes.
          </p>
        </div>
      </div>

      {/* ACTIONS BAR (SEARCH BOX & ADD CLIENT BUTTON) */}
      <div className="manage-clients-actions-bar" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px", marginBottom: "20px" }}>
        <div className="manage-clients-search-box-wrapper" style={{ position: "relative", flex: 1, maxWidth: "400px" }}>
          <svg 
            className="manage-clients-search-icon" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor" 
            style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", width: "18px", height: "18px", color: "#94a3b8" }}
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            placeholder="Search by client name or mobile..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="manage-clients-search-input"
            style={{ width: "100%", padding: "10px 12px 10px 40px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "14px" }}
          />
        </div>
        <button 
          className="manage-clients-btn-add-client" 
          onClick={() => navigate("/clients/add")}
          style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 16px", borderRadius: "6px", border: "none", background: "#0f172a", color: "#fff", fontWeight: "bold", cursor: "pointer" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ width: "16px", height: "16px" }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add Client
        </button>
      </div>

      {/* TABLE DATA SECTION */}
      {loading ? (
        <div className="manage-clients-loading-wrapper" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px", gap: "12px" }}>
          <div className="manage-clients-spinner" style={{ width: "30px", height: "30px", border: "3px solid #f3f3f3", borderTop: "3px solid #0f172a", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
          <p style={{ color: "#64748b", fontSize: "14px" }}>Syncing Registry Database...</p>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      ) : (
        <>
          <div className="manage-clients-table-wrapper" style={{ background: "#fff", borderRadius: "8px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
            <table className="manage-clients-pro-table" style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
              <thead>
                <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                  <th style={{ padding: "12px 16px", width: "80px", color: "#475569", fontWeight: "700" }}>ID</th>
                  <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "700" }}>Client Name</th>
                  <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "700" }}>Mobile</th>
                  <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "700" }}>License Status</th>
                  <th style={{ padding: "12px 16px", textAlign: "center", width: "120px", color: "#475569", fontWeight: "700" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredClients.length > 0 ? (
                  filteredClients.map((c) => (
                    <tr key={c.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                      
                      {/* ID Column */}
                      <td className="manage-clients-text-bold" style={{ padding: "16px", fontFamily: "monospace", color: "#64748b", fontWeight: "600" }}>
                        #{c.id}
                      </td>

                      {/* Client Name & Network Badge Inline */}
                      <td style={{ padding: "16px" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                          <span className="manage-clients-name-text" style={{ fontWeight: "600", color: "#1e293b", fontSize: "15px" }}>
                            {c.customer_name || "N/A"}
                          </span>
                          <span className="manage-clients-network-badge" style={{ fontSize: "11px", alignSelf: "flex-start", background: "#f1f5f9", padding: "2px 6px", borderRadius: "4px", color: "#475569", border: "1px solid #e2e8f0" }}>
                            {c.network_name || "N/A"}
                          </span>
                        </div>
                      </td>

                      {/* Mobile Column */}
                      <td style={{ padding: "16px", fontFamily: "monospace", color: "#334155" }}>
                        {c.phone || "No Phone"}
                      </td>

                      {/* License Status Badge */}
                      <td style={{ padding: "16px" }}>
                        <span className={`manage-clients-status-badge ${c.license_status === "suspended" ? "inactive" : "active"}`}>
                          {c.license_status || "trial"}
                        </span>
                      </td>

                      {/* Actions Button */}
                      <td style={{ padding: "16px", textAlign: "center" }}>
                        <button 
                          className="manage-clients-btn-action-edit" 
                          onClick={() => navigate(`/clients/edit/${c.id}`)}
                          style={{ padding: "6px 14px", borderRadius: "4px", border: "1px solid #cbd5e1", background: "#fff", cursor: "pointer", fontWeight: "600", fontSize: "13px", color: "#1e293b" }}
                        >
                          Edit Node
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="manage-clients-no-data-cell" style={{ textAlign: "center", padding: "32px", color: "#64748b" }}>
                      ⚠️ No responsive nodes linked in database.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* FINAL BOTTOM POSITION BACK BUTTON */}
          <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "24px" }}>
            <button 
              onClick={() => navigate("/")} 
              style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 20px", borderRadius: "6px", border: "1px solid #cbd5e1", background: "#fff", cursor: "pointer", fontWeight: "bold", color: "#334155" }}
            >
              ← Back to Dashboard
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ManageClients;